export default {"src":"/_next/static/media/no-data.f5dc6996.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};